import React from 'react';
import axios from 'axios';
import ModuleTable from 'Components/Core/ModuleTable';
import FormSelectText from 'Components/Core/Form/FormSelectText';
import DialogSelectText from 'Components/Core/Form/DialogSelectText';
import RezeptView from './RezeptView';
import RezeptEdit from './RezeptEdit';
import './Rezepte.css';

export default function Rezepte(props) {

    const x = props.x;
	const selectKategorieId = props.id + '-select-kategorie';
	const viewDialogId = props.id + '-view';
	const editDialogId = props.id + '-edit';

	const [currentKategorieId, setCurrentKategorieId] = React.useState(0);
	const [searchTerm, setSearchTerm] = React.useState('');
	const [viewRezept, setViewRezept] = React.useState(null);
	const [tableReloadKey, setTableReloadKey] = React.useState(0);
	const editReturnToView = React.useRef(true);

	function openEdit() {
		const rezept = viewRezept || {};
		editReturnToView.current = true;
		x.wad[editDialogId].setTitle("Rezept bearbeiten");
		x.waf.setAddSend(editDialogId, 'id', rezept.rezeptid);
		x.waf.set(editDialogId, 'kategorieid', rezept.kategoriename);
		x.waf.setKey(editDialogId, 'kategorieid', rezept.kategorieid);
		x.waf.set(editDialogId, 'name', rezept.name);
		x.waf.set(editDialogId, 'description', rezept.description);
		x.wad[editDialogId].show();
	}

	function openNew() {
		editReturnToView.current = false;
		x.wad[editDialogId].setTitle("Neues Rezept anlegen");
		x.waf.setAddSend(editDialogId, 'id', 0);
		x.waf.set(editDialogId, 'kategorieid', '');
		x.waf.setKey(editDialogId, 'kategorieid', 0);
		x.waf.set(editDialogId, 'name', '');
		x.waf.set(editDialogId, 'description', '');
		x.wad[editDialogId].show();
	}

	function onEditCancel() {
		if (editReturnToView.current) x.wad[viewDialogId].show();
	}

	function onRezeptSaved() {
		setTableReloadKey((key) => key + 1);
		if (editReturnToView.current) {
			setViewRezept((current) => (current === null) ? current : {
				...current,
				name: x.waf.get(editDialogId, 'name'),
				description: x.waf.get(editDialogId, 'description'),
				kategorieid: x.waf.getKey(editDialogId, 'kategorieid'),
				kategoriename: x.waf.get(editDialogId, 'kategorieid'),
			});
			x.wad[viewDialogId].show();
		}
	}

	async function getKategorieList() {
		const kategorieList = [{ 'id': 0, 'name': 'Alle Kategorien' }];
		const result = await axios.get('/Backend/webapp.php?module=Rezepte&task=KategorieList');
		result.data.content.forEach((kategorie) => {
			kategorieList.push({ 'id': kategorie.kategorieid, 'name': kategorie.name });
		});
		return kategorieList;
	}

	const selectKategorieTag =
		<FormSelectText
			id={selectKategorieId}
			iconMode={false}
			wafId="form-current-kategorie"
			name="kategorieid"
			componentId={x.wau.getComponentId()}
			moduleId={props.id}
			x={x}
			classes="form-select-kategorie"
			default=""
			defaultKey={0}
			title="Alle Kategorien"
			alwaysShowSelection={false}
			afterSelect={(key) => {
				setCurrentKategorieId(key);
			}}
			resetIcon={false}
		/>

	const addRezeptTag =
		<span className="bi bi-plus-square module-icon" title="Neues Rezept anlegen" onClick={openNew}></span>

	const searchTag =
		<span className="rezepte-search-wrap">
			<input
				type="text"
				className="table-filter-input rezepte-search-input"
				placeholder="Volltextsuche…"
				title="Volltextsuche über Titel, Beschreibung und Kategorie"
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
			/>
			{searchTerm !== '' &&
				<i
					className="bi bi-x-circle table-filter-clear"
					title="Suche zurücksetzen"
					onClick={() => setSearchTerm('')}
				></i>
			}
		</span>

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="rezeptid"
				dialogFormId={"unused-form-" + props.id}
				x={x}
				classes={`module-rezepte`}
				tableClasses={`rezepte-list`}
				title={props.title}
				addDeleteRow={true}
				hideAddButton={true}
				module="Rezepte"
				listTask="RezeptList"
				listParams={'&kategorieid=' + currentKategorieId + '&search=' + encodeURIComponent(searchTerm)}
				reloadKey={currentKategorieId + '-' + tableReloadKey + '-' + searchTerm}
				extraToolbar={<>{addRezeptTag}{selectKategorieTag}</>}
				customFilterRow={searchTag}
				deleteTask="RezeptDelete"
				onAddHeader={(addHeader) => {
					addHeader('Titel');
					addHeader('Kategorie');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'name':
							return value;
						case 'kategoriename':
							return value ?? 'Ohne Kategorie';
						default:
							return false;
					}
				}}
				onRowClick={(e, rowFields) => {
					setViewRezept(rowFields);
					x.wad[viewDialogId].show();
				}}
			/>
			<DialogSelectText
				id={selectKategorieId}
				moduleId={props.id}
				x={x}
				classes="dialog-select-kategorie"
				onSetData={getKategorieList}
				title="Nach Kategorie filtern"
			/>
			<RezeptView id={viewDialogId} x={x} rezept={viewRezept} onEdit={openEdit} />
			<RezeptEdit id={editDialogId} x={x} title="Rezept bearbeiten" onCancel={onEditCancel} onSaved={onRezeptSaved} />
		</React.Fragment>
	)


};
